import { Box, Skeleton, Typography } from '@mui/material'
import React from 'react'
import useHistories from '../../hooks/useHistories'
import useHistory from '../../hooks/useHistory'
import BodyHeader from '../molecules/BodyHeader'
import CardLeftRight from '../molecules/CardLeftRight'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'

import halfChairIcon from '../../media/halfChair_icon.svg'
import arrowDownloadIcon from '../../media/arrow_download_icon.svg'

const History = () => {
	const { isLoading, title, content } = useHistory()
	const { histories } = useHistories()

	return (
		<>
			{(isLoading && <Skeleton />) || (
				<BodyHeader title={title} list={histories}>
					{content}
				</BodyHeader>
			)}

			<Zone color="ivory">
				{(histories &&
					histories.map(({ id, date, title, description, srcset, image }, index) => (
						<Box key={id}>
							<TitleSubtitle title={date} id={date} subtitle={title} />
							<CardLeftRight
								src={srcset}
								image={image}
								hasRightTitle={index % 2 === 1}
								imgFirst={true}
							>
								<Typography
									sx={{
										'& ul': { pl: 0 },
										'& li': {
											fontSize: 18,
											fontWeight: 800,
											mb: 2,
											background: (theme) =>
												`url(${halfChairIcon}) no-repeat ${theme.spacing(0, 1)}`,
											pl: 4.5,
											display: 'table',
										},
										'& .wp-block-file a': {
											display: 'table',
											color: 'secondary.main',
											textDecoration: 'none',
											fontSize: 16,
											fontWeight: 700,
											cursor: 'pointer',
											background: `url(${arrowDownloadIcon}) no-repeat right`,
											pr: 3,
											mt: 5,
										},
									}}
									dangerouslySetInnerHTML={{ __html: description }}
								></Typography>
							</CardLeftRight>
						</Box>
					))) || <></>}
			</Zone>
		</>
	)
}

export default History
